/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropbox_UnavailableInputs */

const en_dropbox_unavailable = /** @type {(inputs: Dropbox_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dropbox is not available yet. Please try again later.`)
};

const es_dropbox_unavailable = /** @type {(inputs: Dropbox_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dropbox aún no está disponible. Vuelve a intentarlo más tarde.`)
};

/**
* | output |
* | --- |
* | "Dropbox is not available yet. Please try again later." |
*
* @param {Dropbox_UnavailableInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dropbox_unavailable = /** @type {((inputs?: Dropbox_UnavailableInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropbox_UnavailableInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dropbox_unavailable(inputs)
	return en_dropbox_unavailable(inputs)
});